<template>
  <app-layout>
    <template v-slot:header>
      <h2>New Product</h2>
      <flash-messages />
    </template>
        
    <template v-slot:default>
      <div class="row pt-3">
        <div class="col-12">
          <form @submit.prevent="store">
            <div class="row mb-2">
              <div class="form-group col-sm-4">
                <jet-label class="mb-1" for="name" value="Name" />
                <jet-input id="name" type="text" class="form-control sm-input-mobile" v-model="form.name" autocomplete="name" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
              </div>
              <div class="form-group col-sm-4">
                <jet-label class="mb-1" for="sku" value="SKU" />
                <jet-input id="sku" type="text" class="form-control sm-input-mobile" v-model="form.sku" autocomplete="sku" />
                <jet-input-error :message="form.errors.sku" class="mt-2" />
              </div>
              <div class="form-group col-sm-4">
                <jet-label class="mb-1" for="manufacturer" value="Manufacturer" />
                <jet-input id="manufacturer" type="text" class="form-control sm-input-mobile" v-model="form.manufacturer" autocomplete="manufacturer" />
                <jet-input-error :message="form.errors.manufacturer" class="mt-2" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-group col-sm-6">
                <jet-label class="mb-1" for="short_description" value="Short Description" />
                <textarea id="short_description"  class="form-control" v-model="form.short_description" ></textarea>
                <jet-input-error :message="form.errors.short_description" class="mt-2" />
              </div>

              <div class="form-group col-sm-6">
                <jet-label class="mb-1" for="long_description" value="Long Description" />
                <ckeditor id="long_description" :editor="editor"  v-model="form.long_description"
                  :config="editorConfig"></ckeditor>
                <jet-input-error :message="form.errors.long_description" class="mt-2" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-group col-sm-4">
                <jet-label class="mb-1" for="price_msrp" value="Pricing - MSRP" />
                <jet-input id="price_msrp"  type="number" step=".01" class="form-control sm-input-mobile" v-model="form.price_msrp" />
                <jet-input-error :message="form.errors.price_msrp" class="mt-2" />
              </div>
              <div class="form-group col-sm-4">
                <jet-label class="mb-1 " for="wholesale_price_fixed" value="Pricing - Wholesale" />
                <jet-input id="wholesale_price_fixed"  type="number" step=".01" class="form-control sm-input-mobile" v-model="form.wholesale_price_fixed" />
                <jet-input-error :message="form.errors.wholesale_price_fixed" class="mt-2" />
              </div>
              <div class="form-group col-sm-4">
                <jet-label class="mb-1 " for="user_price" value="Pricing - User" />
                <jet-input id="user_price"  type="number" step=".01" class="form-control sm-input-mobile" v-model="form.user_price" />
                <jet-input-error :message="form.errors.user_price" class="mt-2" />
              </div>
            </div>

            <div class="bottom-button">
              <jet-button class="px-5" btnStyle="success" :disable="form.processing" type="submit">Create Product</jet-button>
            </div>
          </form>
        </div>
      </div>
    </template>
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import FlashMessages from '@/Shared/FlashMessages'
  import JetButton from '@/Jetstream/Button'
  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'

  import CKEditor from '@ckeditor/ckeditor5-vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import UploadAdapter from '@/UploadAdapter';

  export default {
    metaInfo: { title: 'Create Product' },
    components: {
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      AppLayout,
      FlashMessages,

      ckeditor: CKEditor.component
    },
    remember: 'form',
    props: ['manufacturers'],
    data() {
      return {
          editor: ClassicEditor,
          editorConfig: {
              extraPlugins: [this.uploader],
              product: this.product
          },
        form: this.$inertia.form({
          name: null,
          sku: null,
          manufacturer: null,
          short_description: null,
          long_description: null,
          price_msrp: 0,
          user_price: 0,
          wholesale_price_fixed: 0,
        }),
      }
    },
    methods: {
      store() {
        this.form.post(this.route('mtd.products.store'))
      },

      uploader(editor) {
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
            return new UploadAdapter( loader, editor.config._config.product );
        };
      },
    },
  }
</script>
